import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { onAuthStateChanged, signOut } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";

import { auth, db } from './firebase/config';
import { setUser } from './store/slices/authSlice';

import Login from './components/auth/Login';
import AdminLayout from './components/layout/AdminLayout';
import RegistroNino from './components/admin/RegistroNino';
import ListaEstudiantes from './components/admin/ListaEstudiantes';
import PagoComprobante from './components/padres/PagoComprobante';
import GestionPagos from './components/admin/GestionPagos';
import DashboardHome from './components/admin/DashboardHome';
import LandingPage from './components/landing/LandingPage';
import RegistroAdministrador from './components/admin/RegistroAdministrador';
import ListaAcudientes from './components/admin/ListaAcudientes';
import GenerarPDF from './components/admin/GenerarPDF';
function App() {
  const dispatch = useDispatch();
  const { isLoggedIn, isAuthorized, loading } = useSelector((state) => state.auth);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        const userDoc = await getDoc(doc(db, "usuarios_autorizados", user.email));
        if (userDoc.exists()) {
          const authorizedUser = userDoc.data();
          dispatch(setUser({
            uid: user.uid,
            email: user.email,
            displayName: user.displayName,
            photoURL: user.photoURL,
            role: authorizedUser.rol || 'admin',
            isAuthorized: true
          }));
        } else {
          await signOut(auth);
          dispatch(setUser(null));
        }
      } else {
        dispatch(setUser(null));
      }
    });
    return () => unsubscribe();
  }, [dispatch]);

  if (loading) return (
    <div className="flex h-screen items-center justify-center">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
    </div>
  );

  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage />} />

        <Route
          path="/login"
          element={(isLoggedIn && isAuthorized) ? <Navigate to="/admin" /> : <Login />}
        />

        <Route path="/pago/:uid" element={<PagoComprobante />} />

        {/* Rutas Privadas: Nota que los hijos NO llevan "/" al inicio */}
        <Route
          path="/admin"
          element={(isLoggedIn && isAuthorized) ? <AdminLayout /> : <Navigate to="/login" />}
        >
          <Route index element={<DashboardHome />} />
          <Route path="registrar" element={<RegistroNino />} />
          <Route path="estudiantes" element={<ListaEstudiantes />} />
          <Route path="acudientes" element={<ListaAcudientes />} />
          <Route path="pagos" element={<GestionPagos />} />
          <Route path="generar-pdf" element={<GenerarPDF />} />
          <Route path="registrar-admin" element={<RegistroAdministrador />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;